<template>
    <v-container>
      <v-card class="mx-auto" flat>
        <v-row >
          <v-col>
            <p class="headline font-weight-bold text-center" style="color:#AF8936; font-size: 27px !important;">
              Estadística de Sentencias Publicadas
            </p>
          </v-col>
        </v-row>
        <v-divider class="mb-9"></v-divider>
        <v-row justify="center">
          <v-data-table
            :headers="headers"
            :items="listTocasTotal"
            :items-per-page="5"
            class="elevation-1"
            hide-default-footer
            disable-pagination
          >
          <template v-slot:item.total_anterior = "{item}">
            <div class="text-right">{{ item.total_anterior }}</div>
          </template>
          <template v-slot:item.total_nuevo= "{item}">
            <div class="text-right">{{ item.total_nuevo }}</div>
          </template>
          <template v-slot:item.total= "{item}">
            <div class="text-right">{{ item.total }}</div>
          </template>
          <template v-slot:item.eliminadas= "{item}">
            <div class="text-right">{{ item.eliminadas }}</div>
          </template>
          <template slot="body.append">
          <tr class="brown--text">
            <th><div class="title">Totales</div></th>
            <th><div class="text-right title">{{ sumField('total_anterior')}}</div></th>
            <th><div class="text-right title">{{ sumField('total_nuevo')}}</div></th>
            <th><div class="text-right title">{{ sumField('total')}}</div></th>
            <th><div class="text-right title">{{ sumField('eliminadas')}}</div></th>
          </tr>
          </template>
          </v-data-table>
        </v-row>

      </v-card>

</v-container>

</template>

<script>
import { mapGetters } from 'vuex';

  export default {
    data () {
      return {
        headers: [
          {
            text: 'Sala',
            align: 'start',
            sortable: false,
            value: 'salas_data.nombre',
            class: "grey-text title"
          },
          { text: 'Anteriores al 1 de FEBRERO 2021', value: 'total_anterior',class: "grey-text ", sortable: false, },
          { text: 'Posteriores al 1 de FEBRERO 2021', value: 'total_nuevo',class: "grey-text", sortable: false, },
          { text: 'Total de Tocas', value: 'total',class: "grey-text", sortable: false, },
          { text: 'Eliminadas', value: 'eliminadas',class: "grey-text", sortable: false, }
        ],
      }
    },
    computed:{
      ...mapGetters([
        "listTocasTotal"
      ])
    },
    mounted(){
      this.getSalasCount()
    },
    methods:{
      sumField(key) {
        // sum data in give key (property)
        return this.listTocasTotal.reduce((a, b) => a + (b[key] || 0), 0)
      },
      getSalasCount() {
        this.$store.dispatch("GET_TOTAL_TOCAS_COUNT",  { url: "/tocas/salas/count" } )
        .then(response => {
        })
        .catch(error => {
          console.log(error);
        });
      },
    }

  }
</script>
